import styled from 'styled-components';
import { AiOutlineInfoCircle } from "react-icons/ai";

export default function KPIDisplay ({ sticky, expenses, income, revenue, property }) {
  return (
    <KPIContainer className={sticky ? "sticky" : ""}>
      <KPICard>
        <h3 className="flex items-center">
          Estimated Property Value
          <div 
            data-tip="Bezla's best estimate of this property's market value. It is not an appraisal, and it should be used as a starting point."
            className={sticky ? "tooltip tooltip-bottom cursor-help" : "tooltip tooltip-top cursor-help"}
          >
            <AiOutlineInfoCircle className="w-4 h-4" />
          </div> 
        </h3>
        <div className="value">{property}</div>
      </KPICard>

      <KPICard>
        <h3>Net Operating Income</h3>
        <div className="value">{income}</div>
      </KPICard>

      <KPICard>
        <h3>Total Expenses</h3>
        <div className="value">{expenses}</div>
      </KPICard>
      
      <KPICard>
        <h3>Total Gross Rooms Revenue</h3>
        <div className="value">{revenue}</div>
      </KPICard>
    </KPIContainer>
  );
};

const KPIContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
  padding: 0rem 0rem 2rem 0rem;

  &.sticky {
    position: sticky;
    z-index: 999;
    top: 80px;
    background: white;
  }
`;

const KPICard = styled.div`
  background: transparent;
  padding: 1rem;
  box-shadow: 0px 4px 17px -2px rgba(0, 0, 0, 0.08);
  min-width: 200px;
  background: white;
  font-family: "Noto Sans", sans-serif;
  
  &:hover {
    box-shadow: inset 4px 0px 0px 0px rgb(87, 87, 87),
      0px 4px 17px -2px rgba(0, 0, 0, 0.15);
  }

  h3 {
    color: #000;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .value {
    color: #000;
    font-size: 30px;
    font-weight: 600;
  }
`;
